"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_idea__or__innovation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "261ef356-ee1c-45f9-9e3f-36ddfcb0a1a1",
    "data-name": "know-how_ic_hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d18e9bc6-fbb6-42d8-b04d-6e583dc6b4f1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.85,116h10a7,7,0,0,1,7,7v17a0,0,0,0,1,0,0h-24a0,0,0,0,1,0,0V123A7,7,0,0,1,90.85,116Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eaac1736-0dcc-4b34-b55c-f9df94f5976a",
    x1: 95.26,
    y1: -19.66,
    x2: 140.67,
    y2: 46.68,
    gradientTransform: "translate(-8.76 57.64) rotate(-10.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "67e6423c-2d79-402b-8f45-55af7e0fc481",
    x1: 112.52,
    y1: 122.4,
    x2: 112.52,
    y2: 147.77,
    gradientTransform: "matrix(0.84, -0.84, 1.98, 1.98, -252.6, -22.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "know-how-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,66.37c0-.8,0-1.6-.06-2.4v-.15C144.48,39.18,125.28,17,97.89,16l-1.74,0-1.74,0C67,17,47.83,39.18,46.57,63.82V64c0,.8-.06,1.6-.06,2.4,0,0,0,.09,0,.13h0a50.58,50.58,0,0,0,6.72,25,79.62,79.62,0,0,0,5.93,9s9,10.5,9,23.5v4c0,4.42-.42,8,4,8h48c4.42,0,4-3.58,4-8v-4c0-13,9-23.5,9-23.5a79.62,79.62,0,0,0,5.93-9,50.58,50.58,0,0,0,6.72-25h0S145.81,66.41,145.81,66.37Z",
    transform: "translate(0 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d18e9bc6-fbb6-42d8-b04d-6e583dc6b4f1)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 137,
    x2: 88,
    y2: 117,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 137,
    x2: 104,
    y2: 117,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,134H72c-3.46,0-4-2.2-4-5.27,0,4.08-.17,7.27,4,7.27h48c4.17,0,4-3.19,4-7.27C124,131.8,123.46,134,120,134Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,128.73c0-.85,0-1.77,0-2.73v2C124,128.25,124,128.49,124,128.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,126c0,1,0,1.88,0,2.73,0-.24,0-.48,0-.73Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,116h10a7,7,0,0,1,7,7v17a0,0,0,0,1,0,0h-24a0,0,0,0,1,0,0V123A7,7,0,0,1,90.85,116Z",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 92.5,
    width: 10,
    height: 23.5,
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 116,
    x2: 92,
    y2: 93,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 116,
    x2: 100,
    y2: 93,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.11,32a43.16,43.16,0,0,0-50,1,2,2,0,0,0,1.49,3.64,55.86,55.86,0,0,1,61.82,42.31,2,2,0,0,0,3.93.08A43.16,43.16,0,0,0,119.11,32Z",
    transform: "translate(0 0)",
    fill: "url(#eaac1736-0dcc-4b34-b55c-f9df94f5976a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.92,
    cy: 37.58,
    r: 2.03,
    transform: "translate(-5.81 12.59) rotate(-10.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.85,79c.91.11,7.5,3,13.5-.5a18.62,18.62,0,0,0,8.5,2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,79s-8,2.5-13.5-.5a18.62,18.62,0,0,1-8.5,2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.35,116a95.16,95.16,0,0,0-5-18.5A95.18,95.18,0,0,0,73.85,79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.35,116a95.12,95.12,0,0,1,14.5-37",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86.84 77.5 92 93 100 93 104.84 77.5",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,136h48a0,0,0,0,1,0,0v24a12,12,0,0,1-12,12h-24a12,12,0,0,1-12-12V136A0,0,0,0,1,71.85,136Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,136h48a0,0,0,0,1,0,0v24a12,12,0,0,1-12,12h-24a12,12,0,0,1-12-12V136A0,0,0,0,1,71.85,136Z",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,176h-8a4,4,0,0,1-4-4h16A4,4,0,0,1,99.85,176Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,176h-8a4,4,0,0,1-4-4h16A4,4,0,0,1,99.85,176Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,174h-8a4,4,0,0,1-3.45-2h-.55a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4h-.55A4,4,0,0,1,99.85,174Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,170h-24a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12h24a12,12,0,0,0,12-12v-2A12,12,0,0,1,107.85,170Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,144l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,144Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,144l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,144Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,152l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,152Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,152l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,152Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,160l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,160Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,160l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,160Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,144l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,144Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,152l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,152Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,160l-48,4a2,2,0,0,1-2.16-2h0a2,2,0,0,1,1.83-2l48-4a2,2,0,0,1,2.16,2h0A2,2,0,0,1,120,160Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,142l-48,4a2,2,0,0,1-1.88-1A2,2,0,0,0,72,148l48-4a2,2,0,0,0,1.83-2,2,2,0,0,0-.28-1A2,2,0,0,1,120,142Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,150l-48,4a2,2,0,0,1-1.88-1A2,2,0,0,0,72,156l48-4a2,2,0,0,0,1.83-2,2,2,0,0,0-.28-1A2,2,0,0,1,120,150Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,158l-48,4a2,2,0,0,1-1.88-1A2,2,0,0,0,72,164l48-4a2,2,0,0,0,1.83-2,2,2,0,0,0-.28-1A2,2,0,0,1,120,158Z",
    transform: "translate(0 0)",
    fill: "#333",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.84,160H120a2,2,0,0,0-.15-4v-4H120a2,2,0,0,0-.15-4v-4H120a2,2,0,0,0-.15-4v-4H72.06l-.14.14L107.77,172h.07A12,12,0,0,0,119.84,160Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#67e6423c-2d79-402b-8f45-55af7e0fc481)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_idea__or__innovation;
exports.default = _default;